import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import egam from "../../services/egam";
import { getClientData } from "../../services/auth";
import { queryKeys } from "../api/queryKeys";
import { CondicoesParams, CondicoesResponse } from "../../types/Parcelamento";

export const useCondicoes = (
  params: CondicoesParams | null,
  enabled: boolean = true
) => {
  return useQuery<CondicoesResponse>({
    queryKey: queryKeys.condicoes(params),
    queryFn: async () => {
      if (!params || !params.parcela || !params.intervalo || !params.prazo) {
        throw new Error("Parâmetros não fornecidos");
      }

      const clientData = getClientData();
      if (!clientData) {
        throw new Error("Cliente não autenticado");
      }

      const formData = new FormData();
      formData.append("pedidoExterno", "true");
      formData.append("totalLiquido", params.totalLiquido.toFixed(2));
      formData.append("totalMedicamentos", params.totalMedicamentos.toFixed(2));
      formData.append("totalPerfumaria", params.totalPerfumaria.toFixed(2));
      formData.append("NR_PARCELAS", params.parcela);
      formData.append("QT_DIAS_INTERVALO", params.intervalo);
      formData.append("PZ_MEDIO", params.prazo);

      const response = await egam.post<CondicoesResponse>(
        "pedidos/finalizar/parcelamento/prazoMedio",
        formData
      );

      if (response.data && response.data.msg_err) {
        const errorMsg = String(response.data.msg_err);
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }

      return response.data;
    },
    enabled:
      enabled &&
      params !== null &&
      params.parcela !== "" &&
      params.intervalo !== "" &&
      params.prazo !== "",
    staleTime: 0, // Sempre refetch quando os parâmetros mudarem
    refetchOnMount: "always", // Sempre refetch quando o componente montar
  });
};
